import { render, staticRenderFns } from "./MandateName.vue?vue&type=template&id=b9839e06&"
import script from "./MandateName.vue?vue&type=script&lang=js&"
export * from "./MandateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports